import { Route, Routes } from 'react-router-dom';
import './App.css';
import Register from './components/Register';
import CreateProfile from './components/CreateProfile';
import Apps from './components/Apps';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';
import ActiveSurveys from './components/ActiveSurveys';
import MySurveys from './components/MySurveys';
import Invite from './components/Invite';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import PushSurvey from './components/Admin/PushSurvey';
import CompletedSurveys from './components/Admin/CompletedSurveys';
import OngoingSurveys from './components/Admin/OngoingSurveys';
import UsersData from './components/Admin/UsersData';
import ForgotPassword from './components/ForgotPassword';
import { PushNotifications } from '@capacitor/push-notifications';
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import Profile from './components/Profile';
import PrivacyPolicy from './components/PrivacyPolicy';
import AccountDeletionPage from './components/AccountDeletionPage';

const addListeners = async () => {
  await PushNotifications.addListener('registration', token => {
    console.info('Registration token: ', token.value);
  });

  await PushNotifications.addListener('registrationError', err => {
    console.error('Registration error: ', err.error);
  });

  await PushNotifications.addListener('pushNotificationReceived', notification => {
    console.log('Push notification received: ', notification);
  });

  await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
    console.log('Push notification action performed', notification.actionId, notification.inputValue);
  });
}

const registerNotifications = async () => {
  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!');
  }

  await PushNotifications.register();
}

const getDeliveredNotifications = async () => {
  const notificationList = await PushNotifications.getDeliveredNotifications();
  console.log('delivered notifications', notificationList);
}

function App() {

  const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
  useEffect(() => {
     
if (isPushNotificationsAvailable) {

  if (registerNotifications()) {
    addListeners();
    getDeliveredNotifications();
  }
    //  this.initPushNotifications();
    //  if (registerNotifications()) {
    //    addListeners();
    //    getDeliveredNotifications();
    //  }
}
  }, []);

  return (
    <div>
      <Routes>
        <Route path='/' element={<Login />}></Route>
        <Route path='/register' element={<Register />}></Route>
        <Route path='/forgot-password' element={<ForgotPassword />}></Route>
        <Route path='/profile' element={<CreateProfile />}></Route>
        <Route path='/profile/app' element={<Apps />}></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
        <Route path='/delete-account' element={<AccountDeletionPage />}></Route>
        <Route path='/dashboard' element={<Dashboard />}>
          <Route path='/dashboard' element={<DashboardHome />}></Route>
          <Route path='/dashboard/my-profile' element={<Profile />}></Route>
          <Route path='/dashboard/active-surveys' element={<ActiveSurveys />}></Route>
          <Route path='/dashboard/my-surveys' element={<MySurveys />}></Route>
          <Route path='/dashboard/invite' element={<Invite />}></Route>
          <Route path='/dashboard/survey-points' element={<MySurveys />}></Route>
        </Route>
        <Route path='/admin-dashboard' element={<AdminDashboard />}>
          <Route path='/admin-dashboard' element={<PushSurvey />}></Route>
          <Route path='/admin-dashboard/completed-surveys' element={<CompletedSurveys />}></Route>
          <Route path='/admin-dashboard/ongoing-surveys' element={<OngoingSurveys />}></Route>
          <Route path='/admin-dashboard/users' element={<UsersData />}></Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
